import { type FC } from 'react';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// screen
import { StructuredDataInfo } from 'modules/map/components/daily-consolidate-invoice/types';
import { SMALL_FONT_SIZE } from 'modules/map/components/pdf-print-form/utils';

const PdfFooter: FC<{ footerInfo: StructuredDataInfo }> = ({ footerInfo }) => {
  return (
    <Box sx={{ mt: 1, pageBreakInside: 'avoid', breakInside: 'avoid' }}>
      <Typography
        sx={{
          mb: 1,
          fontWeight: 600,
          fontSize: SMALL_FONT_SIZE,
          textAlign: 'end',
        }}
      >
        Hà Nội, ngày.........tháng..........năm {footerInfo.year}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Box sx={{ width: '50%', textAlign: 'center' }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: SMALL_FONT_SIZE,
              mb: 10,
            }}
          >
            Người lập
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: SMALL_FONT_SIZE,
            }}
          >
            {footerInfo.menuAccountingOfficer}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PdfFooter;
